import axiosServices from './request';

const BookApi = axiosServices('/book/v1.0');

export default {

  /** 获取指定模板的封面图 */
  getCoverByTempletId: BookApi('get', 'bookCover/getCoverByTempletId'),

  /** 获得图书标签 */
  getBookLabels: BookApi('get', 'book/getBookLabels'),

  /** 获取书刊列表 */
  listPage4Adviser: BookApi('get', 'book/listPage4Rays7'),

  /** 通过isbn获取书刊信息 */
  getByIsbnAndTypeCodeFromRaysData: BookApi('get', 'book/getByIsbnAndTypeCodeFromRaysData'),

  /** 创建书刊 */
  createBook4Rays7: BookApi('post', 'book/createBook4Rays7'),

  /** 通过二维码id获取图书信息 */
  getBookBaseInfoBySceneId: BookApi('get', 'book/getBookBaseInfoBySceneId'),

  /** 获取第三方资源 */
  getThirdResources: BookApi('get', 'appletThirdResources/getThirdResources'),

  /** 获取第三方来源 */
  getNewsSourceList: BookApi('get', 'appletHome/getNewsSourceList'),

  /** 删除书刊 */
  deleteBook4Adviser: BookApi('get', 'bookAdviser/deleteBook4Adviser'),

  /** 获取书刊详情 */
  getById4Agent: BookApi('get', 'book/getById4Agent'),

  getBookById: BookApi('get', 'book/getById'),

  /** 修改图书 */
  updateBookAndBookType: BookApi('post', 'book/updateBookAndBookType'),
  /**获取6.0编辑书刊列表 */
  getListPage4Adviser: BookApi('get', 'book/listPage4Adviser'),
  /**获取6.0出版社书刊列表 */
  getListPage4Agent: BookApi('get', 'book/listPage4Agent'),
  /**创建6.0书刊 */
  createScene4Rays7FromRays6: BookApi('post', 'book/createScene4Rays7FromRays6'),
  /**获取公众号二维码配置的企业微信群 */
  getWxworkQrcodeListBySceneOrBookGroup: BookApi('get', 'bookWxwork/getWxworkQrcodeListBySceneOrBookGroup'),
  /**公众号设置企业微信 */
  setWxworkQrcode: BookApi('post', 'bookWxwork/setWxworkQrcode'),
  /**书刊列表 */
  listPage4Push: BookApi('get', 'book/listPage4Push')
};